import { createSlice } from "@reduxjs/toolkit"
import { AclPageState } from "./types"
import { fetchAclList, fetchVisibilityAclTable, fetchSetAcl, fetchDeleteAcl } from "./acl-thunk"
import { ErrorType } from "@/shared/types"

const initialState: AclPageState = {
    aclList: [],
    visibilityAclTable: [],
    isLoading: false,
    isVisibilityTableLoading: false,
    isFirstLoad: true,
    error: null,
}

const aclSlice = createSlice({
    name: 'acl',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchAclList.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchAclList.fulfilled, (state, action) => {
                state.isFirstLoad = false
                state.isLoading = false
                state.aclList = action.payload
                state.error = null
            })
            .addCase(fetchAclList.rejected, (state, action) => {
                state.error = action.payload as ErrorType
                state.isLoading = false
            })
            .addCase(fetchVisibilityAclTable.pending, (state) => {
                state.isVisibilityTableLoading = true
                state.error = null
            })
            .addCase(fetchVisibilityAclTable.fulfilled, (state, action) => {
                state.isVisibilityTableLoading = false
                state.visibilityAclTable = action.payload
                state.error = null
            })
            .addCase(fetchVisibilityAclTable.rejected, (state, action) => {
                state.error = action.payload as ErrorType
                state.isVisibilityTableLoading = false
            })
            .addCase(fetchSetAcl.fulfilled, (state, action) => {
                state.aclList = [...state.aclList, action.payload]
            })
            .addCase(fetchDeleteAcl.fulfilled, (state, action) => {
                state.aclList = state.aclList.filter((acl) => acl.id !== action.meta.arg)
            })
    },
})

export default aclSlice.reducer
